const template = require('lodash/template');
const GlobalAlerts = require('../../functions/GlobalAlerts.js');
const Lang = require('lang');
const modalTriggers = $('#expenses-table tr[data-link]');

/**
 * Inicializando o js da tela de relatorios
 */
function init() {
  // Clicks defaults
  $(document).on('click', '#expenses-table tr[data-link]', tableRowListeners);
  // Clicks de outro tipo de source (botão do meio do mouse, etc)
  $(document).on('auxclick', '#expenses-table tr[data-link]', tableRowListeners);
}

/*
* Função para somar dois valores que possuem 2 casas decimais e evitar inconsistências de ponto flutuante do JavaScript
* @param {number} number1
* @param {number} number2
* @return {number}
*/
function sumValuesWithTwoDecimals(number1, number2) {
  const result = (number1 * 100 + number2 * 100) / 100;
  return parseFloat(result.toFixed(2));
}

/**
 * Aplica os listeners nas rows da página de relatório
 * Utiliza o modelo antigo contido no arquivo rateioInput para listar e setar os valores
 */
function applyRateio(despesa, modal) {
  const despesaRateio = despesa.rateios || [];

  if (despesaRateio.length === 0) { return; }

  const rateio = modal.find('#despesas-container');

  const template_string = $('#rateio').html().replace(/&gt;/g, '>').replace(/&lt;/g, '<');
  const _template = template(template_string);
  let count = 0;
  let quantRateio = 0;

  despesaRateio.forEach(function (item, n) {
    const inputId = '#idEmpresaReembolsante' + count;

    rateio.append(_template({
      count: count
    }));

    const rateioById = rateio.find('#rateio' + count);
    const valorRateioInput = rateio.find('#valorRateio' + count);

    const rateioByIdFormatted = parseFloat(item.percentual).toFixed(2).replace('.', ',');
    rateioById.val(rateioByIdFormatted);

    // verifica se é o último elemento e se tem mais de um elemento
    if (despesaRateio.length > 1 && n + 1 === despesaRateio.length) {
      // calcula a soma dos percentuais
      const sum = despesaRateio.slice(0, -1).reduce((acc, current) => {
        const percentualWithTwoDecimals = parseFloat(current.percentual).toFixed(2);
        return sumValuesWithTwoDecimals(acc, parseFloat(percentualWithTwoDecimals));
      }, 0);

      // calcula o percentual do último elemento
      const lastPercentage = sumValuesWithTwoDecimals(100, -sum);
      const lastPercentageFormatted = lastPercentage.toFixed(2).replace('.', ',');

      rateioById.val(lastPercentageFormatted);
    }

    const valorDespesa = despesa.valor || 0;
    const valorRateio = (valorDespesa / 100) * item.percentual;
    valorRateioInput.val(valorRateio.toFixed(2));
    $(valorRateioInput).trigger('change');

    const input = `<input id="${inputId}" disabled class="form-control" name="${inputId}" type="text" value="${item.descricao}">`;
    const select = rateio.find(inputId);

    select.replaceWith(input);

    count++;
    quantRateio++;
  });

  rateio.find('.remove').remove();
  rateio.find('.add').remove();
  rateio.find('input').prop('disabled', true);
}

/**
 * Aplica os listeners nas rows da página de relatório
 */
function tableRowListeners(event) {
  event.preventDefault();


  // Validação do listener antigo para confirmar os targets
  const target = event.target;
  const targetTagName = target.tagName.toLowerCase();

  if ((targetTagName !== 'tr' && targetTagName !== 'td') || target.classList.contains('checkbox-cell')) {
    return;
  }

  const $target = targetTagName == 'tr'
    ? $(target)
    : $(target).closest('tr[data-link]');

  // Caso seja um click com a tecla ctrl ou o botão de scroll do mouse abre em outra tela
  if (event.ctrlKey || (event.button && event.button === 1)) {
    return window.open($target.data('link'));
  }

  // ID da despesa
  const id = $target.data('expense-id')

  // Resposta simulada da despesa

  const modal = $(`#modal-despesa-${id}`);

  // Inputs de radio do TR
  const initialApprovalStatus = $target.find('label input:checked').parent().hasClass('form-danger') ? true : false;

  const expenseIndex = $target.index();

  // Se o modal atual já existir só abre ele
  if (modal.length > 0) {
    // Desabilita ou habilita o botão dependendo do input selecionado inicialmente
    if (initialApprovalStatus) {
      modal.find('#disapprove').prop('disabled', true)
    } else {
      modal.find('#approve').prop('disabled', true)
    }

    return modal.modal('toggle');
  }

  // Replace para remover erros no safari
  const template_string = $('#modal-despesa-template').html().replace(/&gt;/g, '>').replace(/&lt;/g, '<');
  const _template = template(template_string);

  nifty.body.overlay('show');
  // Request para pegar os dados da despesa dinamicamente
  return $.ajax({
    url: route('app.despesas.show-json', id),
    method: 'GET',
  })
    .then((despesa) => {
      despesa.titulo = !!despesa.titulo ? despesa.titulo : 'Sem título';
      despesa.imagem = !!despesa.imagem ? despesa.imagem : { url: 'none', nome: 'none' };
      despesa.id = id;

      const modalTemplate = $.parseHTML(_template({ despesa }));

      $('.content').append(modalTemplate);

      const expenseModal = $(`#modal-despesa-${despesa.id}`);

      // Aplica os dados do rateio e gera a lista dos rateios
      despesa.rateios && expenseModal && applyRateio(despesa, expenseModal);

      // Se tiver imagem e for do tipo imagem esconde os dados do pdf, e vise e versa
      // Se não tiver imagem ou pdf remove os elementos de pdf e imagem
      if (!!despesa.imagem && despesa.imagem.url !== 'none') {
        despesa.imagem.tipo === 'IMG' ? expenseModal.find('[data-pdf]').remove() : expenseModal.find('[data-img]').remove();
        expenseModal.find('[data-no-img], [data-no-attachment]').remove();
      } else {
        expenseModal.find('[data-pdf], [data-img]').remove();
        expenseModal.find('[data-no-img]').parent().addClass('no-attachment');
      }

      // Confirma se tem anexo, se tiver mostra a div com a listagem e gera os elementos do anexo
      if (!!despesa.anexos) {
        expenseModal.find('#listagem-anexos').removeClass('hidden');

        despesa.anexos.map((item) => {
          const html = `
          <div class="anexos-item">
            <a href="${item.url}" target="_blank">${item.nome}</a>
          </div>
        `;
          expenseModal.find('#listagem-anexos').append(html);
        });
      }

      // Se a despesa for reembolsável setta a checkbox pra active
      despesa.reembolsavel && expenseModal.find('#reembolsavel').parent().addClass('active');

      $(document).on('click', `#modal-despesa-${id} #go_to_expense`, function () {
        window.open(route('app.despesas.show', id));
      });

      despesa.isReversal && expenseModal.find('#card-alert').addClass('card-alert');

      if (despesa.podeEditar) {
        $(document).on('click', `#modal-despesa-${id} #edit_expense`, function () {
          window.open(`${route('app.despesas.show', id)}#modal-despesa`);
        });
      } else {
        expenseModal.find('#edit_expense').remove();
      }

      if (despesa.podeDeletar) {
        $(document).on('click', `#modal-despesa-${id} [data-type="deletion"]`, function () {
          const form = $(this).closest('form');

          bootbox.confirm({
            size: 'medium',
            buttons: {
              confirm: {
                label: 'Deletar',
                className: 'btn btn-danger'
              },
              cancel: {
                label: 'Cancelar',
                className: 'btn btn-default'
              }
            },
            title: Lang.get('js/relatorios/show.delete_expense_title'),
            message: Lang.get('js/relatorios/show.delete_expense_message'),
            callback: function (result) {
              if (!result) { return; }

              // Corrige o action do form
              const action = form.attr('action');

              nifty.body.overlay('show');
              expenseModal.modal('hide');

              $.ajax({
                method: 'POST',
                url: `${action}/${id}`,
                data: {
                  _token: form.find('input[name="_token"]').val(),
                  _method: form.find('input[name="_method"]').val(),
                }
              })
                .then(() => {
                  nifty.body.overlay('show');
                  window.location.reload();
                })
                .catch(() => {
                  expenseModal.modal('show');
                  GlobalAlerts.createAndShow({
                    type: 'danger',
                    title: Lang.get('js/common/phrases.ops'),
                    message: Lang.get('js/common/phrases.unexpected_error'),
                  });
                });

              nifty.body.overlay('hide');
            }
          });
        });
      } else {
        expenseModal.find('[data-type="deletion"]').remove();
      }

      const arrowLeft = expenseModal.find('.left-arrow');

      const arrowRight = expenseModal.find('.right-arrow');

      if (expenseIndex == 0) {
        arrowLeft.addClass('hidden');
      } else {
        arrowLeft.on('click', function (e) {
          expenseModal.modal('hide');
          $target.prev().trigger('click');
        });
      }

      if (expenseIndex == modalTriggers.length - 1) {
        arrowRight.addClass('hidden');
      } else {
        arrowRight.on('click', function (e) {
          expenseModal.modal('hide');
          $target.next().trigger('click');
        });
      }

      expenseModal.modal('toggle');

      nifty.body.overlay('hide');
    })
    .catch(() => {
      GlobalAlerts.createAndShow({
        type: 'danger',
        title: Lang.get('js/common/phrases.ops'),
        message: Lang.get('js/common/phrases.unexpected_error')
      });
      nifty.body.overlay('hide');
    });
}

module.exports = {
  init: init,
  url: /^\/relatorios\/\d+/,
}
